import { UploadTimeoutError } from "@/lib/upload-timeout";

/**
 * User-facing message for a failed onboarding document upload. Kept as a pure
 * function (no react-native imports) so it can be unit-tested in the Node test
 * environment, same reasoning as `upload-timeout.ts`.
 *
 * `sent` is how many files in the batch were uploaded before the failure. Those
 * are taken off the sheet, so Upload only sends the rest (a retry used to send
 * them again as duplicates).
 */
export function describeUploadFailure(err: unknown, sent = 0): string {
    const what = err instanceof UploadTimeoutError ? "Upload timed out." : "Upload failed.";
    if (sent > 0) {
        const files = sent === 1 ? "1 file was" : `${sent} files were`;
        return `${what} ${files} sent. Check your connection and tap Upload to send the rest.`;
    }
    return `${what} Check your connection and tap Upload to try again — your files are still here.`;
}
